<form [formGroup]="form">
  <mat-form-field appearance="outline" class="w-75">
    <mat-label>{{ "COMPONENTS.COACH_REQUEST.TIME" | translate }}</mat-label>
    <input matInput #time [formControlName]="givenFormControlName" readonly />
    <button mat-icon-button matSuffix (click)="openTimePicker()"><mat-icon>access_time</mat-icon></button>
    <app-error [control]="form.controls.time"></app-error>
  </mat-form-field>
</form>
